import {
  apiPlugin,
  storyblokInit,
  useStoryblokApi,
  type StoryblokClient,
} from "@storyblok/svelte";
import { PUBLIC_SB_API_ACCESS_TOKEN, PUBLIC_PREVIEW } from "$env/static/public";

import Page from "$lib/Page.svelte";
import Post from "$lib/views/Post.svelte";

let client: StoryblokClient;

export function getClient() {
  if (!client) {
    storyblokInit({
      accessToken: PUBLIC_SB_API_ACCESS_TOKEN,
      use: [apiPlugin],
      bridge: PUBLIC_PREVIEW === "true",
      components: {
        // define only top-level components; these will be built directly into
        // the main app bundle
        page: Page,
        post: Post,
      },
      apiOptions: {
        https: true,
        region: "us",
        cache: {
          type: "none",
          clear: "auto",
        },
      },
    });

    client = useStoryblokApi();
    return client;
  }

  return client;
}
